import React, { useMemo } from 'react';
import NodeInfo from './NodeInfo';
import ProteinVariantListInfoPanel from './ProteinVariantListInfoPanel';
import './projectSidePanel.scss';

interface Props {
  nodeMenuDetails: any[];
  type: string;
  header: string;
  treeNodeId: number;
  onRefreshTreeNodeAfterProteinVariantChange: (
    treeNodeId: number,
    isVariantExist: boolean,
  ) => void;
  showProteinVariantModal: boolean;
  setShowProteinVariantModal: (show: boolean) => void;
}

const ProteinSidePanel = ({
  nodeMenuDetails,
  type,
  header,
  treeNodeId,
  onRefreshTreeNodeAfterProteinVariantChange,
  showProteinVariantModal,
  setShowProteinVariantModal,
}: Props) => {
  const getNodeInfo = useMemo(() => {
    const nodeComponents = [];
    nodeMenuDetails.forEach((nodeMenuDetail) => {
      nodeComponents.push(
        <NodeInfo
          labelName={nodeMenuDetail.labelName}
          info={nodeMenuDetail.info}
          treeNodeType={type}
        />,
      );
    });
    return nodeComponents;
  }, [nodeMenuDetails]);

  return (
    <div id="proteinsidepanel-panel-container" className="protein-info-panel-container">
      <div id="proteinsidepanel-panel-section" className="protein-info-panel-section">
        <div id="proteinsidepanel-panel-header" className="row protein-info-panel-header">
          <div id={`proteinsidepanel-panel-title-${header}`} className="col-6">{header}</div>
        </div>
        {getNodeInfo}
      </div>
      <ProteinVariantListInfoPanel
        treeNodeId={treeNodeId}
        onRefreshTreeNodeAfterProteinVariantChange={
          onRefreshTreeNodeAfterProteinVariantChange
        }
        showProteinVariantModal={showProteinVariantModal}
        setShowProteinVariantModal={setShowProteinVariantModal}
      />
    </div>
  );
};
export default ProteinSidePanel;
